import { supabase } from "@/lib/supabaseClient";

export async function getSessionAndMemberStatus() {
  const { data: { session }, error: sessErr } = await supabase.auth.getSession();
  if (sessErr) throw sessErr;

  if (!session?.user) {
    return { session: null, isAnon: false, isMember: false };
  }

  const isAnon =
    session.user?.is_anonymous === true ||
    session.user?.user_metadata?.is_anonymous === true;

  if (isAnon) {
    return { session, isAnon: true, isMember: false };
  }

  const { data: member, error: memErr } = await supabase
    .from("members")
    .select("status")
    .eq("auth_user_id", session.user.id)
    .maybeSingle();

  if (memErr) throw memErr;

  const isMember = member?.status === "active";
  return { session, isAnon: false, isMember };
}

// Optional new helper you can use elsewhere later
export async function getAuthedMemberProfile() {
    const { session, isAnon, isMember } = await getSessionAndMemberStatus();
    if (!session || isAnon || !isMember) return { session, isAnon, isMember, profile: null };
  
    const uid = session.user.id;
  
    const metaFirst =
      session.user?.user_metadata?.first_name ??
      session.user?.user_metadata?.firstName ??
      null;
  
    // Try fetch
    const { data: existing, error: profErr } = await supabase
      .from("users")
      .select("first_name,last_name,email,phone_e164,country,auth_user_id")
      .eq("auth_user_id", uid)
      .maybeSingle();
  
    if (profErr) throw profErr;
  
    // If missing, create it (safe upsert)
    if (!existing) {
      const { data: created, error: upErr } = await supabase
        .from("users")
        .upsert(
          {
            auth_user_id: uid,
            email: session.user.email,      // your table has email unique
            first_name: metaFirst,          // seed from metadata
          },
          { onConflict: "auth_user_id" }
        )
        .select("first_name,last_name,email,phone_e164,country,auth_user_id")
        .maybeSingle();
  
      if (upErr) throw upErr;
  
      return { session, isAnon, isMember, profile: created ?? null };
    }
  
    return { session, isAnon, isMember, profile: existing };
  }
  
